export const ADMIN_ROLE_ALIASES: Record<string, string[]> = {
  Commish: ["Commish", "OrganizationAdmin", "LeagueAdmin"],
  OrganizationAdmin: ["OrganizationAdmin", "Commish"],
  LeagueAdmin: ["LeagueAdmin", "Commish"],
  Parent: ["Parent", "Parents"],
  Parents: ["Parent", "Parents"]
};

export const expandRole = (role: string): string[] => ADMIN_ROLE_ALIASES[role] ?? [role];

export const hasAnyRole = (userRoles: string[], allowedRoles: string[]) => {
  if (allowedRoles.length === 0) {
    return true;
  }
  const expandedAllowed = new Set(allowedRoles.flatMap(expandRole));
  return userRoles.some((role) => expandedAllowed.has(role));
};

export const isProgramAdmin = (userRoles: string[]) =>
  hasAnyRole(userRoles, ["SuperAdmin", "OrganizationAdmin", "LeagueAdmin", "Commish"]);

export const isBaseballStaff = (userRoles: string[]) =>
  hasAnyRole(userRoles, ["SuperAdmin", "OrganizationAdmin", "LeagueAdmin", "Commish", "Coach", "Evaluator"]);
